const Modal = ({ title, onClose, children }) => {
  return (
    <div className="admin-modal-overlay" onClick={onClose}>
      <div className="admin-modal-content theme-card p-4" onClick={(e) => e.stopPropagation()}>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4 className="text-white mb-0">{title}</h4>
          <button type="button" className="btn-close btn-close-white" aria-label="Close" onClick={onClose} />
        </div>
        {children}
      </div>
    </div>
  );
};

export default Modal;
